import styled from 'styled-components';

export const TagSelectContainer = styled.div`
  width: 100%;
  margin: 8px 0;

  .tag-select-label {
    display: block;
    font-size: 12px;
    color: var(--gray-main-color, #6b6b6b);
    margin-bottom: 4px;
  }

  .tag-select__control {
    background-color: transparent;
    border-radius: 4px;
    min-height: 40px;
    z-index: 2;
  }

  .tag-select__menu {
    z-index: 999999;
  }

  .tag-select__placeholder {
    font-size: 14px;
  }
`;
